import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import WasteRegisterGenerator from 'components/WasteRegisters/WasteRegisterGenerator'
import WasteRegisterSelector from 'components/WasteRegisters/WasteRegisterSelector'
import ContratEntity from 'utils/__interfaces/Perimeter/ContratEntity'
import {
  distinctArray,
  uniqueById,
  getArrayIds,
} from 'utils/Common/array-utils'

const WasteRegister = () => {
  const [finalList, setFinalList] = useState<string[]>([])
  const [selectedContratIds, setSelectedContratIds] = useState<string[]>([])
  const [selectedContrats, setSelectedContrats] = useState<ContratEntity[]>([])
  const handlefinalListRemove = (itemIds: string[]) => {
    // remove items from the list of selected contracts
    const myArray = finalList.filter(function (el) {
      return !itemIds.includes(el)
    })
    setFinalList(myArray)

    // remove items from the list of contracts Entity data
    const filteredListContratsData = selectedContrats.filter(
      (contrat: ContratEntity) => !itemIds.includes(contrat.id)
    )
    setSelectedContrats(filteredListContratsData)
  }
  useEffect(() => {
    setFinalList(distinctArray(selectedContratIds))
  }, [selectedContratIds])

  const { t } = useTranslation()
  return (
    <>
      <div className="wasteRegister_titleSection">
        <h2>{t('wasteRegister.mainTitle')}</h2>
        <span>{t('wasteRegister.info')}</span>
      </div>
      <div className="wasteRegister">
        <WasteRegisterSelector
          onContratSelected={setSelectedContratIds}
          onDataContratSelected={setSelectedContrats}
          contratItemsDatas={selectedContrats}
          finalKeptIds={finalList}
          setFinalList={setFinalList}
        />
        <WasteRegisterGenerator
          contratsData={uniqueById(
            selectedContrats.filter((item) => finalList.includes(item.id))
          )}
          checkedList={getArrayIds(
            uniqueById(
              selectedContrats.filter((item) => finalList.includes(item.id))
            )
          )}
          selectedCount={finalList.length}
          handleRemoveitems={handlefinalListRemove}
        />
      </div>
    </>
  )
}

export default WasteRegister
